export default __webpack_public_path__ + "static/media/auth_small_google.2ae6fd27.svg";